<template>
    <div>
        <v-container fluid class="d-print-none">
            <v-row no-gutters>
                <v-col cols="8">
                    <h1 class="headline font-weight-light mb-3">DEFECTIVE</h1>
                </v-col>
                <v-col :cols="4" class="text-right">
                    <v-text-field
                        v-model="form_search_singlepart"
                        label="Search Singlepart / Enter"
                        single-line
                        solo
                        rounded
                        dense
                        @keyup.enter="func_search_sg()"
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="4"
                    class="mar-t-20"
                    v-if="team_name == 'INVENTORY'"
                >
                    <v-btn rounded small color="amber" @click="get_send_claim()"
                        ><v-icon class="mr-1">mdi-cube-send</v-icon> Send
                        claim</v-btn
                    >
                </v-col>

                <v-col
                    cols="4"
                    class="mar-t-20"
                    v-if="team_name != 'INVENTORY'"
                >
                    <v-btn
                        rounded
                        small
                        color="amber"
                        :disabled="checkboxHq.length == 0"
                        @click="view_send_hq()"
                        ><v-icon class="mr-1">mdi-cube-send</v-icon> send to hq
                        : {{ checkboxHq.length }}</v-btn
                    >
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="11" sm="5" md="3">
                    <v-autocomplete
                        :items="data_supplier"
                        item-text="project_name"
                        item-value="project_id"
                        menu-props="auto"
                        v-model="form_search.project_id"
                        label="Select Project"
                        hide-details
                        @change="change_supplier()"
                    ></v-autocomplete>
                </v-col>
                <v-col
                    cols="11"
                    sm="5"
                    md="3"
                    v-if="form_search.project_id != ''"
                >
                    <v-autocomplete
                        :items="data_partno"
                        item-text="part_name"
                        item-value="part_id"
                        menu-props="auto"
                        v-model="form_search.part_id"
                        label="Select Part"
                        hide-details
                        @change="change_part()"
                    ></v-autocomplete
                ></v-col>
                <v-col cols="1" class="mt-4">
                    <v-btn
                        x-small
                        fab
                        class="mr-1"
                        v-if="
                            form_search.project_id != '' ||
                                form_search.part_id != ''
                        "
                        @click="reset()"
                    >
                        <v-icon>mdi-rotate-left</v-icon></v-btn
                    >
                </v-col>
            </v-row>
            <v-card>
                <div v-for="(row, index) in data_defective" :key="index">
                    <hr v-if="index != 0" />
                    <hr v-if="index != 0" />
                    <v-row>
                        <v-spacer></v-spacer>
                        <v-col cols="8" sm="9" md="5" lg="3" class="text-right">
                            <!-- <v-autocomplete
                                :items="data_suppliers"
                                item-text="supplier_name"
                                item-value="supplier_id"
                                menu-props="auto"
                                label="Send to Supplier"
                                v-model="form.supplier_id[index]"
                                @change="func_supplier(index)"
                                dense
                            ></v-autocomplete> -->
                        </v-col>
                        <v-col
                            cols="3"
                            sm="2"
                            md="1"
                            class="mt-4 mr-7"
                            v-if="chk_view == index"
                        >
                            <v-btn
                                color="success"
                                rounded
                                small
                                @click="send(index)"
                            >
                                Send Claim</v-btn
                            >
                        </v-col>
                    </v-row>

                    <v-row class="pa-5 mar-t">
                        <v-col cols="12" sm="6" md="4"
                            ><b>Project :</b> {{ row.project_name }}</v-col
                        >
                        <v-col cols="12" sm="6" md="4"
                            ><b>Supplier :</b> {{ row.supplier_name }}</v-col
                        >
                        <v-col cols="12" sm="6" md="4"> </v-col>
                        <v-col cols="12" sm="6" md="4"
                            ><b>Part No :</b> {{ row.part_name }}</v-col
                        >
                        <v-col cols="12" sm="6" md="4"
                            ><b>Part Description :</b>
                            {{ row.part_description }}</v-col
                        >
                        <v-col cols="12" sm="6" md="4"
                            ><b>Category ID :</b> {{ row.category_name }}</v-col
                        >
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-simple-table class="table-inv">
                                <template v-slot:default>
                                    <thead>
                                        <tr class="col-tr-1">
                                            <th class="text-center">#</th>
                                            <th class="text-center">
                                                Single Part
                                            </th>
                                            <th class="text-center">
                                                Branch
                                            </th>
                                            <th class="text-center">
                                                Issue SN
                                            </th>
                                            <th class="text-center">
                                                Defective Type
                                            </th>
                                            <th class="text-center">
                                                Defective Sn
                                            </th>
                                            <th class="text-center">
                                                Created By
                                            </th>
                                            <th class="text-center">
                                                Created At
                                            </th>
                                            <!-- v-if="chk_view === index" -->
                                            <th
                                                class="text-center"
                                                v-if="team_name != 'INVENTORY'"
                                            >
                                                <!-- <v-btn
                                                    :color="colorx"
                                                    rounded
                                                    small
                                                    @click="all(index)"
                                                    class="ml-4"
                                                >
                                                    All
                                                </v-btn> -->
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr
                                            v-for="(n,
                                            num) in row.defective_part"
                                            :key="num"
                                        >
                                            <td>{{ num + 1 }}.</td>
                                            <td>{{ n.singlepart }}</td>
                                            <td>{{ n.branch_name }}</td>
                                            <td>{{ n.issue_sn }}</td>
                                            <td>{{ n.defective_type }}</td>
                                            <td>{{ n.defective_sn }}</td>
                                            <td>{{ n.created_by }}</td>
                                            <td>{{ n.created_at }}</td>
                                            <td
                                                class="text-center"
                                                v-if="team_name != 'INVENTORY'"
                                            >
                                                <v-checkbox
                                                    v-model="checkboxHq"
                                                    label=""
                                                    color="green"
                                                    :value="n"
                                                ></v-checkbox>
                                            </td>
                                        </tr>
                                        <br />
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </div>
                <v-row>
                    <v-col cols="12" class="text-center">
                        <div>
                            <v-btn class="mx-2" fab small @click="back()">
                                <v-icon dark>mdi-chevron-left</v-icon>
                            </v-btn>
                            <v-btn
                                class="mx-2"
                                fab
                                small
                                :color="btn_color(n)"
                                v-for="n in page_count"
                                :key="n"
                                @click="get_defective_page(page_num_show(n))"
                            >
                                {{ page_num_show(n) }}
                            </v-btn>

                            <v-btn class="mx-2" fab small @click="next()">
                                <v-icon dark>mdi-chevron-right</v-icon>
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>
        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>

        <v-row justify="center">
            <v-dialog
                v-model="dialog"
                fullscreen
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="close()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <!-- <v-toolbar-title>Settings</v-toolbar-title> -->
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-list three-line subheader>
                        <v-list-item>
                            <v-list-item-content>
                                <v-row>
                                    <v-col cols="4">
                                        <v-text-field
                                            @keyup="check_search()"
                                            v-model="search_claim"
                                            label="Search "
                                            prepend-inner-icon="mdi-magnify"
                                            outlined
                                            dense
                                        ></v-text-field>
                                    </v-col>
                                    <v-spacer></v-spacer>
                                    <v-col cols="3" v-if="checkbox.length > 0">
                                        <v-autocomplete
                                            :items="data_suppliers"
                                            v-model="suppliers"
                                            item-text="supplier_name"
                                            item-value="supplier_id"
                                            menu-props="auto"
                                            label="Send to Supplier"
                                            outlined
                                            dense
                                        ></v-autocomplete>
                                    </v-col>
                                    <v-col cols="1" v-if="checkbox.length > 0">
                                        <v-btn
                                            :disabled="
                                                suppliers === '' ||
                                                    suppliers === null
                                            "
                                            block
                                            small
                                            color="success"
                                            @click="send()"
                                            ><v-icon small class="mr-1"
                                                >mdi-content-save</v-icon
                                            >
                                            Save</v-btn
                                        >
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-simple-table class="table-inv">
                                            <template v-slot:default>
                                                <thead>
                                                    <tr class="col-tr-1">
                                                        <th class="text-center">
                                                            #
                                                        </th>
                                                        <th class="text-center">
                                                            Single Part
                                                        </th>
                                                        <th class="text-center">
                                                            Part Name
                                                        </th>
                                                        <th class="text-center">
                                                            Part Description
                                                        </th>
                                                        <th class="text-center">
                                                            Branch
                                                        </th>
                                                        <th class="text-center">
                                                            Issue SN
                                                        </th>
                                                        <th class="text-center">
                                                            Defective Type
                                                        </th>
                                                        <th class="text-center">
                                                            Defective Sn
                                                        </th>
                                                        <th
                                                            class="text-center"
                                                        ></th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr
                                                        v-for="(n,
                                                        num) in checkbox"
                                                        :key="num"
                                                    >
                                                        <td>{{ num + 1 }}.</td>
                                                        <td>
                                                            {{ n.singlepart }}
                                                        </td>
                                                        <td>
                                                            {{ n.part_name }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                n.part_description
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{ n.branch_name }}
                                                        </td>
                                                        <td>
                                                            {{ n.issue_sn }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                n.defective_type
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{ n.defective_sn }}
                                                        </td>
                                                        <td class="text-center">
                                                            <v-btn
                                                                @click="del(n)"
                                                                del
                                                                x-small
                                                                fab
                                                                color="red accent-2"
                                                            >
                                                                <v-icon
                                                                    >mdi-close</v-icon
                                                                >
                                                            </v-btn>
                                                        </td>
                                                    </tr>
                                                    <br />
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-col>
                                </v-row>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-dialog>
        </v-row>

        <v-row justify="center">
            <v-dialog
                v-model="dialogHq"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card tile>
                    <v-toolbar flat dark color="primary">
                        <v-btn icon dark @click="close_hq()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>

                        <v-spacer></v-spacer>
                        <v-toolbar-items> </v-toolbar-items>
                    </v-toolbar>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="8" md="10" class="mt-4">
                                <h2>Preview Confirm Send To HQ</h2>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="12" sm="4" md="2" class="mt-4">
                                <v-btn
                                    block
                                    small
                                    color="success"
                                    @click="save_hq()"
                                    ><v-icon small class="mr-1"
                                        >mdi-content-save</v-icon
                                    >
                                    Save
                                </v-btn>
                            </v-col>
                            <v-col cols="12">
                                <v-simple-table class="table-inv">
                                    <template v-slot:default>
                                        <thead>
                                            <tr class="col-tr-1">
                                                <th class="text-center">#</th>
                                                <th class="text-center">
                                                    Single Part
                                                </th>
                                                <th class="text-center">
                                                    Branch
                                                </th>
                                                <th class="text-center">
                                                    Issue SN
                                                </th>
                                                <th class="text-center">
                                                    Defective Type
                                                </th>
                                                <th class="text-center">
                                                    Defective Sn
                                                </th>
                                                <th class="text-center">
                                                    Created By
                                                </th>
                                                <th class="text-center">
                                                    Created At
                                                </th>
                                                <th class="text-center"></th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr
                                                v-for="(n, num) in checkboxHq"
                                                :key="num"
                                            >
                                                <td>{{ num + 1 }}.</td>
                                                <td>{{ n.singlepart }}</td>
                                                <td>{{ n.branch_name }}</td>
                                                <td>{{ n.issue_sn }}</td>
                                                <td>{{ n.defective_type }}</td>
                                                <td>{{ n.defective_sn }}</td>
                                                <td>{{ n.created_by }}</td>
                                                <td>{{ n.created_at }}</td>
                                                <td class="text-center">
                                                    <v-btn
                                                        @click="delHq(n)"
                                                        del
                                                        x-small
                                                        fab
                                                        color="red accent-2"
                                                    >
                                                        <v-icon
                                                            >mdi-close</v-icon
                                                        >
                                                    </v-btn>
                                                </td>
                                            </tr>
                                            <br />
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import axios from "axios"

const url = `${process.env.VUE_APP_ROOT_API}/api/`
import { mapState, mapMutations } from "vuex"

export default {
    created() {
        this.check_search = _.debounce(this.check_search, 500)
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_data()
        this.get_data_supplier()
        this.get_supplier()
    },
    computed: {
        ...mapState(["snackbar"]),
        ...mapState(["isLoading"]),
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        ...mapMutations(["mutateIsLoading"]),
        async get_data() {
            let { data } = await axios.get(
                url +
                    "defective?supplier_id=" +
                    this.form_search.project_id +
                    "&part_id=" +
                    this.form_search.part_id,
                this.tk
            )
            this.data_main = data
            this.data_defective = data.data
            this.page_total = data.last_page
            this.page_total < 7
                ? (this.page_count = this.page_total)
                : (this.page_count = 7)
        },
        async back() {
            let url = this.data_main.prev_page_url
            let { data } = await axios.get(url)
            this.data_defective = data.data
            this.data_main = data
        },
        async get_defective_page(num) {
            this.current_page = num
            if (num != "...") {
                let url_page = url + "defective?page=" + num
                let { data } = await axios.get(url_page, this.tk)
                this.data_defective = data.data
                this.data_main = data
                this.checkboxHq = []
            }
        },
        btn_color(n) {
            if (this.page_count == 7) {
                if (this.data_main.current_page <= 4) {
                    return this.data_main.current_page === n ? "primary" : ""
                } else if (
                    this.data_main.current_page == this.data_main.last_page
                ) {
                    return n === 7 ? "primary" : ""
                } else if (
                    this.data_main.current_page ==
                    this.data_main.last_page - 1
                ) {
                    return n === 6 ? "primary" : ""
                } else if (
                    this.data_main.current_page ==
                    this.data_main.last_page - 2
                ) {
                    return n === 5 ? "primary" : ""
                } else {
                    return n === 4 ? "primary" : ""
                }
            } else {
                return this.data_main.current_page === n ? "primary" : ""
            }
        },
        page_num_show(n) {
            let page = n
            if (this.page_count == 7) {
                let chk2 = 0
                let chk3 = 0
                let chk4 = 0
                let chk5 = 0
                let chk6 = 0
                if (this.data_main.current_page == 1) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data_main.last_page - 1
                } else if (
                    this.data_main.current_page == this.data_main.last_page
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data_main.last_page - 3
                    chk5 = this.data_main.last_page - 2
                    chk6 = this.data_main.last_page - 1
                } else if (this.data_main.current_page == 2) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data_main.last_page - 1
                } else if (
                    this.data_main.current_page ==
                    this.data_main.last_page - 1
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data_main.last_page - 3
                    chk5 = this.data_main.last_page - 2
                    chk6 = this.data_main.last_page - 1
                } else if (this.data_main.current_page == 3) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data_main.last_page - 1
                } else if (
                    this.data_main.current_page ==
                    this.data_main.last_page - 2
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data_main.last_page - 3
                    chk5 = this.data_main.last_page - 2
                    chk6 = this.data_main.last_page - 1
                } else {
                    chk2 = "..."
                    chk3 = this.data_main.current_page - 1
                    chk4 = this.data_main.current_page
                    chk5 = this.data_main.current_page + 1
                    chk6 = "..."
                }

                n === 1 ? (page = 1) : ""
                n === 2 ? (page = chk2) : ""
                n === 3 ? (page = chk3) : ""
                n === 4 ? (page = chk4) : ""
                n === 5 ? (page = chk5) : ""
                n === 6 ? (page = chk6) : ""
                n === 7 ? (page = this.data_main.last_page) : ""
            } else {
                n === 1 ? (page = 1) : ""
                n === 2 ? (page = 2) : ""
                n === 3 ? (page = 3) : ""
                n === 4 ? (page = 4) : ""
                n === 5 ? (page = 5) : ""
                n === 6 ? (page = 6) : ""
            }
            return page
        },
        all(idx) {
            if (this.chk === true) {
                this.chk = false
                this.colorx = "primary"
                this.checkbox = []
            } else {
                this.chk = true
                this.colorx = "success"
                this.checkbox = this.data_defective[idx].defective_part
            }
        },
        async send() {
            await axios
                .post(
                    url + "defective-to-claim ",
                    {
                        supplier_id: this.suppliers,
                        defective_parts: this.checkbox,
                    },
                    this.tk
                )
                .then((response) => {
                    this.close()
                    this.get_data()
                    this.mutatesnackbar()
                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        reset() {
            this.form_search.project_id = ""
            this.form_search.part_id = ""
            this.get_data()
        },
        async get_data_supplier() {
            let { data } = await axios.get(url + "project-has-defective")
            this.data_supplier = data
        },
        async change_supplier() {
            let { data } = await axios.get(
                url + "get-partno/" + this.form_search.project_id
            )
            this.data_partno = data
            this.get_data()
        },
        async change_part() {
            this.get_data()
        },
        async get_supplier() {
            let { data } = await axios.get(url + "supplier")
            this.data_suppliers = data
        },
        func_supplier(idx) {
            this.chk_view = idx
        },
        get_send_claim() {
            this.dialog = true
        },
        close() {
            this.checkbox = []
            this.search_claim = null
            this.dialog = false
        },
        async check_search() {
            if (
                this.search_claim != "" &&
                this.search_claim != null &&
                this.search_claim.length >= 5
            ) {
                this.mutateIsLoading()
                let searchtext = {
                    searchtext: this.search_claim,
                }
                await axios
                    .post(url + "defective/search", searchtext, this.tk)
                    .then((response) => {
                        this.mutateIsLoading()
                        this.search_claim = null
                        if (response.data.defective_id != undefined) {
                            this.checkbox.push(response.data)
                            this.$swal("Successful Search", {
                                icon: "success",
                                button: false,
                                timer: 1000,
                            })
                        } else {
                            this.$swal("Search not found !", {
                                icon: "warning",
                                button: false,
                                timer: 1000,
                            })
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },
        del(n) {
            const filteredItems = this.checkbox.filter((item) => item !== n)
            this.checkbox = filteredItems
        },
        view_send_hq() {
            this.dialogHq = true
        },
        close_hq() {
            this.dialogHq = false
        },
        delHq(n) {
            const filteredItems = this.checkboxHq.filter((item) => item !== n)
            this.checkboxHq = filteredItems
        },
        async save_hq() {
            let send = {
                parts: this.checkboxHq,
            }
            await axios
                .post(url + "defective/transfer-to-hq", send, this.tk)
                .then((response) => {
                    this.checkboxHq = []
                    this.close_hq()
                    this.get_data()
                    this.mutatesnackbar()
                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async func_search_sg() {
            let routeData = this.$router.resolve({
                path: "/Search-Parts",
                query: { q: this.form_search_singlepart },
            })
            window.open(routeData.href, "_blank")
        },
    },
    data() {
        return {
            checkbox: [],
            checkboxHq: [],
            colorx: "primary",
            chk: false,
            item: [],
            page_count: 0,
            data_main: [],
            data_defective: [],
            data_suppliers: [],
            data_supplier: [],
            data_partno: [],
            form_search: {
                project_id: "",
                part_id: "",
            },
            form: {
                supplier_id: [],
            },
            chk_view: -1,
            text: "Success, Your work has been saved",
            tk: null,
            dialog: false,
            search_claim: null,
            suppliers: "",
            team_name: localStorage.team_name,
            dialogHq: false,
            form_search_singlepart: "",
        }
    },
}
</script>
